import { JsonProperty } from '../../core/services/utils/mapping.service';
import { Entity } from './entity.model';

export class CategoryFilter {
  @JsonProperty('name')
  name: string = '';
  @JsonProperty('apiIconUrl')
  apiIconUrl?: string = '';
  @JsonProperty('sort')
  sort: number = 0;
  @JsonProperty('label')
  label: string = '';
  @JsonProperty('iconUrl')
  iconUrl: string = '';
  @JsonProperty('categoryId')
  categoryId?: number = 0;
}

export class Category extends Entity {
  @JsonProperty('sort')
  sort: number = 0;
  @JsonProperty('publish')
  publish: number = 0;
  @JsonProperty()
  iconUrl: string = '';
  @JsonProperty()
  allCustomersEnabled: number = 0;
  @JsonProperty()
  apiIconUrl: string = '';
  @JsonProperty('private')
  private: number = 0;
  @JsonProperty()
  publishBedarflist: number = 0;
  @JsonProperty()
  publishSortiment: number = 0;
  @JsonProperty({ clazz: CategoryFilter })
  categoriesFilters: Array<CategoryFilter> = [];
}
